import {
    FETCH_P24_LOGS,
    FILTER_P24_LOGS
} from "../actions/actionTypes";

import moment from 'moment';

const defaultState = {
    //lista ze wszystkimi logami p24
    p24LogList: [],
    //filtr logów (zawiera zakres dat 'od' i 'do')
    p24LogFilter: {
        startDate: moment().subtract(3, 'days'),
        endDate: moment()
    }
};

export default function p24LogReducer(state = defaultState, action) {
    switch (action.type) {
        case FETCH_P24_LOGS: {
            return {
                ...state,
                p24LogList: action.payload
            };
        }
        case FILTER_P24_LOGS: {
            return {
                ...state,
                p24LogFilter: action.payload
            };
        }
        default:
            return state;
    }
}